export default "/images/vendor/@material-design-icons/svg/filled/arrow_drop_down.svg?d01b5b9fd1dee89d47645c2da720ea16";